import {
  ConsumptionMeterCode,
  OverageDeliveryMethod,
  UsageOverageInvoiceStatus
} from '~/api/graphql';

export const overageMeterLabel = (meterCode: ConsumptionMeterCode): string => {
  switch (meterCode) {
    case ConsumptionMeterCode.PlatformUnit:
      return 'Platform units';
    case ConsumptionMeterCode.KbPage:
      return 'Knowledge base pages';
    case ConsumptionMeterCode.VoiceMinute:
      return 'Voice minutes';
    default:
      return meterCode;
  }
};

export const overageDeliveryCopy = (method: OverageDeliveryMethod): string => {
  if (method === OverageDeliveryMethod.OnNextSubscriptionInvoice) {
    return 'Added to your next subscription invoice';
  }
  return 'Billed as a separate invoice';
};

export const overageInvoiceStatusLabel = (status: UsageOverageInvoiceStatus): string => {
  switch (status) {
    case UsageOverageInvoiceStatus.Pending:
      return 'Scheduled';
    case UsageOverageInvoiceStatus.Paid:
      return 'Paid';
    case UsageOverageInvoiceStatus.Failed:
      return 'Failed';
    case UsageOverageInvoiceStatus.Skipped:
      return 'Skipped';
    default:
      return status;
  }
};

export const overageInvoiceStatusColor = (
  status: UsageOverageInvoiceStatus
): 'zinc' | 'green' | 'red' => {
  switch (status) {
    case UsageOverageInvoiceStatus.Paid:
      return 'green';
    case UsageOverageInvoiceStatus.Failed:
      return 'red';
    default:
      return 'zinc';
  }
};
